import { createTheme } from '@mui/material/styles';
const theme = createTheme();

/**
 * Typography
 * https://lumahealth.clickup.com/t/864egg6k5
 *
 * Demos:
 *
 * - [Typography](https://ui-packages.isbuildingluma.com/ui-core/react-typography/)
 *
 * API:
 *
 * - [Typography API](https://ui-packages.isbuildingluma.com/ui-core/api/typography/)
 * - inherits [MuiTypography API](https://mui.com/material-ui/api/typography/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/N3gFGSM48EkhCahScVFcoK/Luma-Patient-Design-System?node-id=3699%3A4148&mode=dev)
 */
const typography = {
  fontFamily: 'Inter',
  h1: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(36),
    lineHeight: '44px'
  },
  h2: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(24),
    lineHeight: '32px'
  },
  h3: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: '28px'
  },
  h4: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '24px'
  },
  h5: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '20px'
  },
  subtitle1: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: '28px'
  },
  subtitle2: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '24px'
  },
  subtitle3: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '20px'
  },
  body1: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '24px'
  },
  body2: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '20px'
  },
  caption: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: '16px'
  }
};
export default typography;